import { ApolloQueryResult } from '@apollo/client'
import { client } from '../..'

import { Country, ExcelDataInput, ImportExcelDataQuery, ImportExcelDataQueryVariables } from '../../types'

import { IMPORT_EXCEL } from './Queries'

export const importExcel = async (
  companyId: string,
  country: Country,
  year: number,
  excelData: ExcelDataInput[],
): Promise<ApolloQueryResult<ImportExcelDataQuery>> => {
  return client.query<ImportExcelDataQuery, ImportExcelDataQueryVariables>({
    query: IMPORT_EXCEL,
    variables: {
      companyId,
      country,
      year,
      excelData,
    },
    fetchPolicy: 'network-only',
  })
}
